import React from 'react';

const ClassicTemplate = ({ resumeData }) => {
    return (
        <div className="bg-white w-[210mm] min-h-[297mm] shadow-2xl origin-top transform scale-[0.4] md:scale-[0.65] lg:scale-[0.85] xl:scale-100 transition-transform duration-300 p-[20mm] text-slate-900 font-serif" id="resume-preview">

            {/* Header */}
            <div className="text-center border-b border-slate-300 pb-6 mb-8">
                <h1 className="text-3xl font-bold mb-2 text-slate-900">{resumeData.personal.fullName || "Your Name"}</h1>
                <div className="flex justify-center flex-wrap gap-4 text-sm text-slate-600 italic">
                    {resumeData.personal.email && <span>{resumeData.personal.email}</span>}
                    {resumeData.personal.phone && <span>• {resumeData.personal.phone}</span>}
                    {resumeData.personal.location && <span>• {resumeData.personal.location}</span>}
                </div>
            </div>

            {/* Summary */}
            {resumeData.personal.summary && (
                <div className="mb-6">
                    <h2 className="text-lg font-bold border-b border-slate-300 mb-3 pb-1 uppercase tracking-wide text-slate-800">Professional Summary</h2>
                    <p className="text-sm leading-relaxed text-slate-800 text-justify">{resumeData.personal.summary}</p>
                </div>
            )}

            {/* Dynamic Sections */}
            {resumeData.sectionOrder.map((sectionId) => {
                if (sectionId === 'experience' && resumeData.experience.length > 0) {
                    return (
                        <div key={sectionId} className="mb-6">
                            <h2 className="text-lg font-bold border-b border-slate-300 mb-4 pb-1 uppercase tracking-wide text-slate-800">Experience</h2>
                            <div className="space-y-5">
                                {resumeData.experience.map((exp) => (
                                    <div key={exp.id} className="resume-item">
                                        <div className="flex justify-between items-baseline mb-1">
                                            <h3 className="font-bold text-md text-slate-900">{exp.company}</h3>
                                            <span className="text-sm text-slate-600 italic">{exp.startDate} - {exp.endDate}</span>
                                        </div>
                                        <div className="flex justify-between items-center mb-2">
                                            <div className="text-sm font-semibold text-slate-700 italic">{exp.role}</div>
                                            {exp.location && <span className="text-sm text-slate-500">{exp.location}</span>}
                                        </div>
                                        <p className="text-sm leading-relaxed text-slate-800 whitespace-pre-line pl-2 border-l-2 border-slate-100">{exp.description}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    );
                }

                if (sectionId === 'education' && resumeData.education.length > 0) {
                    return (
                        <div key={sectionId} className="mb-6">
                            <h2 className="text-lg font-bold border-b border-slate-300 mb-4 pb-1 uppercase tracking-wide text-slate-800">Education</h2>
                            <div className="space-y-3">
                                {resumeData.education.map((edu) => (
                                    <div key={edu.id} className="resume-item">
                                        <div className="flex justify-between items-baseline">
                                            <h3 className="font-bold text-md text-slate-900">{edu.school}</h3>
                                            <span className="text-sm text-slate-600 italic">{edu.year}</span>
                                        </div>
                                        <div className="text-sm text-slate-700">{edu.degree} {edu.location && `• ${edu.location}`}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    );
                }

                if (sectionId === 'skills' && resumeData.skills.length > 0) {
                    return (
                        <div key={sectionId}>
                            <h2 className="text-lg font-bold border-b border-slate-300 mb-4 pb-1 uppercase tracking-wide text-slate-800">Skills</h2>
                            <div className="text-sm text-slate-800 leading-relaxed">
                                {resumeData.skills.join(" • ")}
                            </div>
                        </div>
                    );
                }

                if (typeof sectionId === 'number') {
                    const section = resumeData.customSections.find(s => s.id === sectionId);
                    if (section && section.items.length > 0) {
                        return (
                            <div key={sectionId} className="mb-6">
                                <h2 className="text-lg font-bold border-b border-slate-300 mb-4 pb-1 uppercase tracking-wide text-slate-800">{section.title}</h2>
                                <div className="space-y-3">
                                    {section.items.map((item) => (
                                        <div key={item.id} className="resume-item">
                                            <div className="flex justify-between items-baseline">
                                                <h3 className="font-bold text-md text-slate-900">{item.title}</h3>
                                                {item.subtitle && <span className="text-sm text-slate-600 italic">{item.subtitle}</span>}
                                            </div>
                                            {item.subtext && <div className="text-sm font-semibold text-slate-700 italic mb-1">{item.subtext}</div>}
                                            {item.description && <p className="text-sm leading-relaxed text-slate-800 whitespace-pre-line pl-2 border-l-2 border-slate-100 mt-1">{item.description}</p>}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        );
                    }
                }

                return null;
            })}
        </div>
    );
};

export default ClassicTemplate;
